import type { SignalItemProps } from './signal-item.interface';
import { useSignals } from '@preact/signals-react/runtime';

const SignalItem = <T,>({ v, i, children, cache }: SignalItemProps<T>) => {
  useSignals();
  const result = typeof children === 'function' ? children(v, i) : children;
  if (cache) {
    cache.set(v, result);
  }
  return result;
};

export { SignalItem };
